<template>
  <section class="section small">
    <div class="container">
      <section
        v-if="
          $store.state.auth.user && $store.state.auth.user.roles.length !== 0
        "
        class="section"
      >
        <Section></Section>
      </section>
      <section class="section small">
        <Roles></Roles>
      </section>
    </div>
  </section>
</template>

<script>
export default {
  components: {
    Roles: () => import("@/components/main/settings/Roles.vue"),
    Section: () => import("@/components/main/settings/Section.vue"),
  },
  created() {},
};
</script>
